import { ReasonsSettingsActions } from "../../../../../../ngapp/src/app/reasons/state/reasons-settings.actions";
import { PreviewEditTemplateActions } from "../../../../../../ngapp/src/app/preview-edit-template/state/preview-edit-template.actions";
import { AdminCentralActions } from "../../../../../../ngapp/src/app/admin-central/state/admin-central.actions";
import { TrackableItemsActions } from "../../../../../../ngapp/src/app/trackable-items/trackable-items.actions";
angular.module("autoremind.users").directive("adminUsersCentralData", [
    "accountService",
    "storeDowngraded",
    "appointmentResourceSettingsSelectorsDowngraded",
    "reasonsSettingsSelectorsDowngraded",
    "previewEditSelectorDowngraded",
    "adminCentralSelectorDowngraded",
    "eventSharingService",
    "trackableItemSelectorDowngraded",
    function (accountService, storeDowngraded, appointmentResourceSettingsSelectorsDowngraded, reasonsSettingsSelectorsDowngraded, previewEditSelectorDowngraded, adminCentralSelectorDowngraded, eventSharingService, trackableItemSelectorDowngraded) {
        return {
            restrict: "E",
            templateUrl: "app/admin/users/admin-users-central-data.html",
            scope: {
                viewModel: "=model",
            },
            link: function (scope, elem, attr) {
                scope.resources = [];
                scope.locations = [];
                scope.providers = [];
                scope.isDataLoadStarted = false;
                scope.itemTypes = [];
                scope.states = [];
                scope.itemLocations = [];
                scope.locationTypes = [];
                // Setup watcher to load data the first time the tab is viewed (even if by route rather than click on tab)
                if (angular.isDefined(scope.viewModel.activeTabIndex)) {
                    scope.$watch("viewModel.activeTabIndex", function (newTabIndex, oldTabIndex) {
                        if (angular.isDefined(newTabIndex) &&
                            !scope.isDataLoaded &&
                            newTabIndex === scope.viewModel.tabIndexes["centraldata"]) {
                            scope.isDataLoadStarted = true;
                            scope.getCentralData();
                        }
                    });
                }
                scope.isVets =
                    accountService.selectedUserHasUserPermission("resource:pets");
                scope.hasOrders = accountService.selectedUserHasUserPermission("communication:trackable:item");
                scope.getCentralData = function () {
                    // TODO: unsubscribe
                    if (scope.viewModel.userId !== 0) {
                        /* storeDowngraded.dispatch(AppointmentResourceSettingsActions.getAppointmentResources({userid: scope.viewModel.userId}));
                                scope.viewModel.loadingIndicatorOld++;
                                var subscribed1 = appointmentResourceSettingsSelectorsDowngraded.selectAppointmentResources()
                                    .subscribe(function (resources) {
                                        if (resources) {
                                            scope.resources = angular.copy(resources);
                                            if (scope.viewModel.loadingIndicatorOld > 0) {
                                                scope.viewModel.loadingIndicatorOld--;
                                            }
                                        }
                                    });
                                    */
                        storeDowngraded.dispatch(AdminCentralActions.getResources({
                            userId: scope.viewModel.userId,
                        }));
                        scope.viewModel.loadingIndicatorOld++;
                        var subscribed1 = adminCentralSelectorDowngraded
                            .selectGetResourcesFromAppointment()
                            .subscribe(function (resources) {
                            if (resources) {
                                var resourcesName = [];
                                for (var i = 0; i < resources.length; i++) {
                                    resourcesName.push(resources[i].resourceName);
                                }
                                scope.resources = angular.copy(resourcesName);
                                if (scope.viewModel.loadingIndicatorOld > 0) {
                                    scope.viewModel.loadingIndicatorOld--;
                                }
                            }
                        });
                        storeDowngraded.dispatch(ReasonsSettingsActions.getRemindersReasons({
                            userId: scope.viewModel.userId,
                        }));
                        scope.viewModel.loadingIndicatorOld++;
                        var subscribed2 = reasonsSettingsSelectorsDowngraded
                            .selectReasons()
                            .subscribe(function (reasons) {
                            if (reasons) {
                                scope.reasons = angular.copy(reasons);
                                if (scope.viewModel.loadingIndicatorOld > 0) {
                                    scope.viewModel.loadingIndicatorOld--;
                                }
                            }
                        });
                        storeDowngraded.dispatch(PreviewEditTemplateActions.getLocationEntities({
                            userId: scope.viewModel.userId,
                        }));
                        scope.viewModel.loadingIndicatorOld++;
                        var subscribed3 = previewEditSelectorDowngraded
                            .selectGetLocationEntities()
                            .subscribe(function (locations) {
                            if (locations) {
                                scope.locations = angular.copy(locations);
                                if (scope.viewModel.loadingIndicatorOld > 0) {
                                    scope.viewModel.loadingIndicatorOld--;
                                }
                            }
                        });
                        storeDowngraded.dispatch(PreviewEditTemplateActions.getProviders({
                            userId: scope.viewModel.userId,
                        }));
                        scope.viewModel.loadingIndicatorOld++;
                        var subscribed4 = previewEditSelectorDowngraded
                            .selectGetProviders()
                            .subscribe(function (providers) {
                            if (providers) {
                                scope.providers = angular.copy(providers);
                                if (scope.viewModel.loadingIndicatorOld > 0) {
                                    scope.viewModel.loadingIndicatorOld--;
                                }
                            }
                        });
                        if (scope.hasOrders) {
                            storeDowngraded.dispatch(TrackableItemsActions.getItemTypes({ userId: scope.viewModel.userId }));
                            scope.viewModel.loadingIndicatorOld++;
                            var subscribed5 = trackableItemSelectorDowngraded
                                .selectItemTypes().subscribe(function (itemTypes) {
                                if (itemTypes) {
                                    scope.itemTypes = angular.copy(itemTypes);
                                    if (scope.viewModel.loadingIndicatorOld > 0) {
                                        scope.viewModel.loadingIndicatorOld--;
                                    }
                                }
                            });
                            storeDowngraded.dispatch(TrackableItemsActions.getStates({ userId: scope.viewModel.userId }));
                            scope.viewModel.loadingIndicatorOld++;
                            var subscribed6 = trackableItemSelectorDowngraded
                                .selectStates().subscribe(function (states) {
                                if (states) {
                                    scope.states = angular.copy(states);
                                    if (scope.viewModel.loadingIndicatorOld > 0) {
                                        scope.viewModel.loadingIndicatorOld--;
                                    }
                                }
                            });
                            storeDowngraded.dispatch(TrackableItemsActions.getLocations({ userId: scope.viewModel.userId }));
                            scope.viewModel.loadingIndicatorOld++;
                            var subscribed7 = trackableItemSelectorDowngraded
                                .selectLocations().subscribe(function (locations) {
                                if (locations) {
                                    scope.itemLocations = angular.copy(locations);
                                    if (scope.viewModel.loadingIndicatorOld > 0) {
                                        scope.viewModel.loadingIndicatorOld--;
                                    }
                                }
                            });
                            storeDowngraded.dispatch(TrackableItemsActions.getLocationTypes({ userId: scope.viewModel.userId }));
                            scope.viewModel.loadingIndicatorOld++;
                            var subscribed8 = trackableItemSelectorDowngraded
                                .selectLocations().subscribe(function (locationTypes) {
                                if (locationTypes) {
                                    scope.locationTypes = angular.copy(locationTypes);
                                    if (scope.viewModel.loadingIndicatorOld > 0) {
                                        scope.viewModel.loadingIndicatorOld--;
                                    }
                                }
                            });
                        }
                    }
                    scope.viewModel.loadingIndicatorOld++;
                    accountService
                        .getCentralDataStats(scope.viewModel.userId)
                        .then(function (stats) {
                        scope.appointmentCount = stats.appointmentCount;
                        scope.personCount = stats.personCount;
                        scope.reasonCount = stats.reasonCount;
                        scope.appointmentTodayCount = stats.appointmentTodayCount;
                        scope.appointmentWeekCount = stats.appointmentWeekCount;
                        scope.petCount = stats.petCount;
                    });
                };
            },
        };
    },
]);
//# sourceMappingURL=admin-users-central-data.js.map